@use "../../variables.scss";

.container {
  min-height: 8rem;
  max-height: 100%;
  flex: 1;

  @media screen and (max-width: variables.$bp-medium) {
    padding-top: 2.4rem;
  }

  &:hover {
    cursor: text;
  }
}

.editor {
  max-height: 100%;
  height: 100%;
  overflow-y: auto;
  width: 100%;
  line-height: 1.8rem;
  color: var(--color-grayscale-white);
  font-size: 1.4rem;
  font-weight: 400;
  position: relative;
  box-sizing: border-box;
  font-family: Inter, sans-serif;
  letter-spacing: 0.3px;
  resize: none;
  background-color: transparent;

  & .tiptap.ProseMirror[contenteditable='true'] {
    min-height: 20vh;
    max-height: 100%;
  }

  &::placeholder {
    color: var(--color-grayscale-shuttle);
  }

  &:focus {
    background-color: transparent !important;
    border-color: var(--color-secondary);
  }

  &:hover {
    cursor: text;
  }

  &[data-error='true'] {
    &:focus {
      border-color: var(--color-error);
    }
  }
}
